export default __webpack_public_path__ + "static/media/thainight3.e3aeb9c4.jpg";